module.exports = __webpack_public_path__ + "static/img/triss.136ea32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/triss.png
// module id = gIq2
// module chunks = 0